export default __webpack_public_path__ + "static/media/271b.45f9daa9.svg";